import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface Ipayload {
  userid: string | null,
  fromdate: string,
  todate: string,
  siteidlist: any,
  cafeidlist: any,
  isallsite: boolean,
  isallcafe: boolean,
  MenuPlanTypeId?: string;
}

const initialState: any = {
  projectionData: [],
  loading: false,
  error: null,
  cutoffdate: null,
  ismppublished: false,
  ishybrid: false
};
interface projectionData {
  daypartmenulist: any;
  cutoffdate: string;
  ismppublished: boolean;
  ishybrid: boolean;
}

export const fetchMenuProjectionData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchMenuProjectionData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetMenuProjection`, payload);
    return response.data.data
  }
);

export const SaveMenuProjection = createAsyncThunk(
  'MenuProjection/SaveMenuProjection',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/SaveMenuProjection`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionPlanCombo = createAsyncThunk(
  'MenuProjection/fetchInitiateMenuPlanCombo',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetProjectionMenuPlanCombo`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionnFoodProgram = createAsyncThunk(
  'MenuProjection/fetchMenuProjectionnFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetProjectionFoodProgramMenu`, payload);
    return response?.data?.data;
  }
);

export const saveMenuProjectionFoodProgram = createAsyncThunk(
  'MenuProjection/saveMenuProjectionFoodProgram',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/saveMenuProjectionFoodProgram`, payload);
    return response?.data?.data;
  }
);

export const fetchMenuProjectionExportData = createAsyncThunk<projectionData, Ipayload>(
  'projections/fetchMenuProjectionExportData',
  async (payload) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/MenuProjection/GetMenuProjectionReport`, payload);
    return response.data.data
  }
);


const projectionDataSlice = createSlice({
  name: 'ProjectionData',
  initialState,
  reducers: {
    updateProjectionData: (state, action) => {
      state.projectionData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenuProjectionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionData.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = [...action.payload.daypartmenulist];
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
        state.ishybrid = action.payload.ishybrid ?? false
      })
      .addCase(fetchMenuProjectionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(SaveMenuProjection.fulfilled, (state) => {
        state.loading = false;
        // state.projectionData = action.payload.daypartmenulist;
        // state.cutoffdate = action.payload.cutoffdate
      })
      .addCase(SaveMenuProjection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionPlanCombo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionPlanCombo.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
        state.ishybrid = action.payload.ishybrid ?? false
      })
      .addCase(fetchMenuProjectionPlanCombo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionnFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionnFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
        state.ishybrid = action.payload.ishybrid ?? false
      })
      .addCase(fetchMenuProjectionnFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(saveMenuProjectionFoodProgram.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveMenuProjectionFoodProgram.fulfilled, (state, action) => {
        state.loading = false;
        state.projectionData = action.payload.daypartmenulist;
        state.cutoffdate = action.payload.cutoffdate
        state.ismppublished = action.payload.ismppublished
      })
      .addCase(saveMenuProjectionFoodProgram.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMenuProjectionExportData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenuProjectionExportData.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchMenuProjectionExportData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { updateProjectionData } = projectionDataSlice.actions;
export default projectionDataSlice.reducer;
